import client from './client';
import qs from "qs";

export const payType = () => client.get(`/api/code/payType`);

/**
 * MOBON 공통코드
 * CODE_TP_ID
 */
export const mobonComCode = (param) => client.get(`/api/code/mobonComCode?`+ qs.stringify(param));

/**
 * 광고 노출 형태 - ADVRTS_PRDT_CODE
 */
export const advrtsPrdtCode = () => client.get(`/api/code/product`);

/**
 * 광고 다바이스 방식 - PLTFOM_TP_CODE
 */
export const pltfomTpCode = () => client.get(`/api/code/platform`);

/**
 * 광고 구현 방식 - MEDIA_ITL_TP_CODE
 */
export const mediaItlTpCode = () => client.get(`/api/code/mediaItlTpCode`);

/**
 * 광고 상품 형태 - SCRIPT_TP_CODE
 */
export const scriptTpCode = () => client.get(`/api/code/scriptTpCode`);

/**
 * 광고 상품 형태 - NFM_TY_TP_CODE ( 07번만 )
 */
export const nfmTyTpCode = () => client.get(`/api/code/nfmTyTpCode`);

/**
 * 광고 노출 권한 - PAR_AUTH_TP_CODE
 */
export const parAuthTpCode = () => client.get(`/api/code/parAuthTpCode`);

/**
 * 광고 노출 권한 - IMAGE_TP_CODE
 */
export const imageTpCode = () => client.get(`/api/code/imageTpCode`);

/**
 * 광고 노출 권한 - MEDIA_SIZE_CODE
 */
export const mediaSizeCode = () => client.get(`/api/code/mediaSizeCode`);

/**
 * 광고 노출 권한 - ADVRTS_RST_CODE
 */
export const advrtsRstCode = () => client.get(`/api/code/advrtsRstCode`);

/**
 * 광고 노출 권한 - LINK_TP_CODE
 */
export const linkTpCode = () => client.get(`/api/code/linkTpCode`);

/**
 * 카테고리 타입 - USER_TP_CODE
 */
export const userTpCode = () => client.get(`/api/code/userTpCode`);

/**
 * OpenRTB 이미지 사이즈 코드
 */
export const openRtbSize = () => client.get(`/api/code/openRTBSize`);

/**
 * OpenRTB 카테고리 코드
 */
export const openRtbCategory = () => client.get(`/api/code/openRtbCategory`);

/**
 * OpenRTB 디폴트지면 - 미등록 지면 신규등록
 */
export const openRtbDefaultMedia = (param) =>
  client.get(`/api/code/openRTBDefaultMedia`, param);

/**
 *  상품 카테고리 매핑
 */
export const CategoryMappingList = (params) =>
  client.get(`/api/manage/category/mapping`, params);

/**
 * 구글 카테고리 리스트
 */
export const googleCategory = () => client.get(`/api/manage/category/google`);

/**
 * 매체카테고리 필터
 */
export const getMediaTpCodeList = (param) =>
  client.get(`/api/code/mediaTpCode`, param);

/**
 * 소재검수 소재상태 구분코드
 */
export const adGrpStateCodeList = (param) =>
  client.get(`/api/code/adGrpStateCode`, param);

/**
 * 소재검수 소재상태 사유 구분코드
 */
export const adGrpRsnCode = (param) =>
  client.get(`/api/code/adGrpRsnCode`, param);

/**
 * 컨버전통계 장바구니,찜 코드
 */
export const cartTpCode = (param) => client.get(`/api/code/cartTpCode`);

/**
 * 매체통계 지면별등급분포 매체지면특성 구분 코드
 */
export const mediaCharacterTpCode = () => client.get(`/api/code/mediaCharacterTpCode`);